import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByDateDsc, orderByDsc } from './format'
import { fetchUsers } from './userAction'

export function fetchProjectSteps() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_PROJECT_STEPS_START", payload: "" })
            console.log("fetch ProjectStep START")
            const res = await axios.get('/projects/steps/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_PROJECT_STEPS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_PROJECT_STEPS",
                    payload: formatList(orderByDateDsc(res.data, "project_step_date"), "project_step_id")
                })
				dispatch({ type: "FETCH_PROJECT_STEPS_FULFILLED", payload: "" })
                
			}            
        } catch(err) {
            console.log("[ERROR] get steps list ", err);
        }
    }
}

export function newProjectStep(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_PROJECT_STEP_START", payload: "" })
            console.log("new ProjectStep START", {data})
            const res = await axios.post('/projects/steps/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_PROJECT_STEP_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_PROJECT_STEP", payload: res.data })
                // update user account
				dispatch({ type: "CREATE_PROJECT_STEP_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new step ", err);
            dispatch({
                type: "CREATE_PROJECT_STEP_ERROR",
                payload: err
            })
        }
    }
}

export function updateProjectStep(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_PROJECT_STEP_START", payload: "" })

            console.log("update Project START")
            const res = await axios.post("/projects/steps/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_PROJECT_STEP_ERROR", dispatch ) ) {               
				dispatch({
                    type: "UPDATE_PROJECT_STEP",
                    payload: data
                })
				dispatch({ type: "UPDATE_PROJECT_STEP_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update project ", err);
            dispatch({
                type: "UPDATE_PROJECT_STEP_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteProjectStep(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_PROJECT_STEP_START", payload: "" })

            console.log("delete step START")
            const res = await axios.post("/projects/steps/delete", {data: data.project_step_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_PROJECT_STEP_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_PROJECT_STEP",
                    payload: data.project_step_id,
                })
                dispatch({ type: "DELETE_PROJECT_STEP_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete step ", err);
            dispatch({
                type: "DELETE_PROJECT_STEP_ERROR",
                payload: err
            })
        }
    }
}

